import React, { Component } from 'react'
import { connect } from 'react-redux';
import { cocktailActions } from '../_actions';

class DeleteButton extends Component {
  handleDeleteItem(_id) {
      if (this.props.collection == 'recipes') {
        this.props.dispatch(cocktailActions.deleteRecipe(_id));
      } else {
        this.props.dispatch(cocktailActions.deleteIngredient(_id));
      }
  }
  
  render() {

      return (
        this.props.user.access_level > 5 &&
            <span>
      {
        this.props.item.deleting ? <em> - Deleting...</em>
          : this.props.item.deleteError ? <span className="text-danger"> - ERROR: {this.props.item.deleteError}</span>
          : <span> - <a onClick={() => { if (window.confirm(`Are you sure you wish to delete ${this.props.item.name}?`)) this.handleDeleteItem(this.props.item._id) } }>Delete</a></span>
      }
          </span>
      )

  }
}



const connectedDeleteButton = connect(null)(DeleteButton);
export { connectedDeleteButton as DeleteButton };


// WEBPACK FOOTER //
// ./src/DeleteButton/DeleteButton.jsx